import formatDate from '../formatDate'
import { Dates } from '../../types'

/** @public */
const formatDates = (selectTwoDates: boolean, dates: Dates, format?: string) => {
  const startDate = formatDate(dates.startDate, format)
  const endDate = formatDate(dates.endDate, format)

  if (selectTwoDates) {
    return startDate ? `${startDate} - ${endDate}` : null
  }
  return startDate
}

export default formatDates
